import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function Website({
  pageLocator,
  primarySite,
  setPrimarySite,
  additionalWebs,
  handleOnChange,
  handleDelete,
  addRow,
  handleSelect,
  webPlatform,
  clientAccountId,
  submitForm,
  onboarding_progress,
}) {
  pageLocator();
  const route = useContext(RouterContext);

  const nextPage = getNextPage(onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === true) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const regex = "https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)"

  // Need to complete pages in progress tracker that do not need to be set up
  const completePages = (pages) => {
    const submitUrl = "/datapulse/onboarding/complete_pages";
    let paramsObject = {
      client_account_id: clientAccountId,
      pages: pages,
    };
    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: true,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        console.log("Completed pages: " + JSON.stringify(pages));
      },
    });
  };
  const incompletePages = (pages) => {
    const submitUrl = "/datapulse/onboarding/incomplete_pages";
    let paramsObject = {
      client_account_id: clientAccountId,
      pages: pages,
    };
    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: true,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        console.log("Incompleted pages: " + JSON.stringify(pages));
      },
    });
  };

  return (
    <>
      <Row className="pb-3 justify-content-center">
        <Col className="mb-2 pb-2 ">
          <p className="pb-3 f28 visby-bold primary text-center">Website</p>
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center text-left">
        <Col lg={6} md={12}>
          <Row className=" justify-content-center">
            <Col className="py-2">
              <p className="f18 visby-bold primary">Website/Domain Details</p>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col className="col-12 py-3 pr-0">
              <p className="primary">
                <strong>Navigate to your website in a browser, and copy and paste the URL directly from the address bar into the field below. </strong> To add
                additional websites or subdomains (ie. if your primary website is "example.com" and you need to add "shop.example.com"), click the 'Add
                subdomain' button to create a new field and follow the same process in the new field with every entry.
              </p>
            </Col>
          </Row>
          <Row className=" pt-2  pb-2 ">
            <Col>
              <Form.Group controlid="primarySite pb-4">
                <Row>
                  <Col>
                    <Form.Label className="pr-3 pb-1 pl-2 trim-padding">
                      <p className="visby-medium f12 light-primary">Primary Website</p>
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Form.Control
                      size="sm"
                      placeholder="https://www.example.com"
                      className="mr-2 mb-2 "
                      style={{ width: "403px", maxWidth: "100%" }}
                      defaultValue={primarySite ? primarySite : ""}
                      onChange={(e) => setPrimarySite(e.target.value)}
                      type="url"
                      pattern="https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)"
                      required
                    />
                    <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group controlid="addSite pb-4">
                <Form.Label className="pr-3 pb-1 pl-2 trim-padding">
                  <p className="visby-medium f12 light-primary">Additional websites/subdomains</p>
                </Form.Label>

                {additionalWebs.map((website, index) => {
                  return (
                    <Row style={{ flexWrap: "nowrap" }} className="m-0 align-items-center" key={website.id}>
                      <Form.Control
                        size="sm"
                        style={{ width: "385px", maxWidth: "100%" }}
                        className=" mr-2 mb-2"
                        placeholder=""
                        value={website.url ? website.url : ""}
                        onChange={(e) => handleOnChange(e, index)}
                      />

                      <button className="pr-0" type="button" onClick={() => handleDelete(website.id)}>
                        <i className="mb-2 fas pr-0 fa-minus-circle"></i>
                      </button>
                    </Row>
                  );
                })}

                <Row className="m-0">
                  <Button onClick={() => addRow()} className="mt-4 mb-2 btn-sm px-4 mr-3 text-center" variant="success">
                    + Add subdomain
                  </Button>
                </Row>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="f18 visby-bold primary pb-2">Website platform</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="f16 nunito-regular pl-2 primary pb-2">What platform is being used?</p>
            </Col>
          </Row>
          <Row>
            <Col className="pb-3">
              <Form.Group controlid="shopOrLead">
                <Form.Control
                  size="sm"
                  as="select"
                  style={{ color: "#2c345b", width: "241px" }}
                  className="pr-0 col-5 website-platform"
                  name="website_platform"
                  onChange={(e) => handleSelect(e.target.value)}
                  defaultValue={webPlatform}
                  required>
                  <option value="" hidden disabled>
                    Choose one
                  </option>
                  <option value="0">Shopify</option>
                  <option value="1">BigCommerce</option>
                  <option value="2">Magento</option>
                  <option value="3">Wordpress</option>
                  <option value="4">Other</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row >
      <Row className="justify-content-center">
        <Col className="mr-4">
          <Row className="navButtonRow">
            <Col>
              <BackButton />
              <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
              <NextButton
                validated={validated}
                btnText={`Next`}
                nextPage={nextPage.url}
                invalidText={`Platform must be selected and valid URL format must include " https:// "`}
                submitForm={submitForm}
                onClick={() => {
                  // Some pages won't be necessary to fill out
                  let pageNames = ["shopify_access", "shopify_authenticate"];
                  if (webPlatform != "0") {
                    completePages(pageNames.map((page) => `/datapulse/onboarding/${page}`));
                  }
                  else {
                    incompletePages(pageNames.map((page) => `/datapulse/onboarding/${page}`));
                  }
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
